import './grid.css';

import './img/blank.png';
import './img/gradient-star.svg';

// prototype images
import './prototype/thumb1.jpg';
import './prototype/thumb2.jpg';
import './prototype/thumb3.jpg';
